import { Select, Textarea } from "@mantine/core";
import { HttpError, IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm } from "@refinedev/mantine";
import DateTimePicker from "components/common/DateTimePicker";
import { UpdateTeaAddonRenewalRun } from "entities/tea_addon_renewal_run";

const runTypeOptions = [
  { value: "renewal", label: "Renewal" },
  { value: "dunning", label: "Dunning" },
];

export const TeaAddonRenewalRunEdit: React.FC<
  IResourceComponentsProps
> = () => {
  const initialValues: UpdateTeaAddonRenewalRun = {
    range_start_at: new Date(),
    range_end_at: new Date(),
    notes: "",
    run_type: "renewal",
  };

  const { getInputProps, saveButtonProps } = useForm<
    UpdateTeaAddonRenewalRun,
    HttpError,
    UpdateTeaAddonRenewalRun
  >({
    initialValues,
    refineCoreProps: {
      redirect: "show",
      queryOptions: {
        select: ({ data }) => ({
          data: {
            range_start_at: data.range_start_at,
            range_end_at: data.range_end_at,
            notes: data.notes,
            run_type: data.run_type,
          },
        }),
      },
    },
  });

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      canDelete={false}
      title="Update Tea Addon Renewal Run"
    >
      <Select
        placeholder="Select run type"
        data={runTypeOptions}
        label="Run Type"
        clearable={false}
        withAsterisk
        mt="sm"
        {...getInputProps("run_type")}
      />
      <DateTimePicker
        type="date"
        label="Range Start At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        {...getInputProps("range_start_at")}
      />
      <DateTimePicker
        type="date"
        label="Range End At"
        defaultValue={new Date()}
        mt="sm"
        min={0}
        max={10}
        {...getInputProps("range_end_at")}
      />
      <Textarea
        defaultValue=""
        mt="sm"
        label="Notes"
        {...getInputProps("notes")}
      />
    </Edit>
  );
};
